module.exports = [{
      plugin: require('/tmp/703ca8ed/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
